import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'

export function useShouldRenderMoreInfoLabel({
	showAsFeatured,
	haveColors,
	hasProductRelatedModelSizes,
}: {
	showAsFeatured: boolean // This products is featured and has a landscape image
	haveColors: boolean // This product has more than one color,
	hasProductRelatedModelSizes: boolean // This product has related model sizes,
}) {
	const { isLargeOrGreater } = useResponsive()
	/**
	 * If is a A2 product (showAsFeatured) and have some colors always render the color link
	 */
	const showAsFeaturedWithColors = showAsFeatured && haveColors

	const shouldRenderColorAmountLabel =
		showAsFeaturedWithColors || (haveColors && isLargeOrGreater)

	const shouldRenderMoreInfoLabel =
		shouldRenderColorAmountLabel || hasProductRelatedModelSizes

	const shouldRenderColorSizesDivider =
		shouldRenderColorAmountLabel && hasProductRelatedModelSizes

	return {
		shouldRenderMoreInfoLabel,
		shouldRenderColorAmountLabel,
		shouldRenderColorSizesDivider,
	}
}
